import { AuthorizedUser } from "../../../api/repositories/backend/models/auth"
import { localize } from "../../../common/services/localization";
import { AuthButton, SubButton, SubFooterButton } from "../functional/buttons"

export const HeroTemplateHeaderClass = "uppercase font-bold text-center lg:text-start text-[18px] lg:text-[26px]";

export const SubOutdated: React.FC<{
    authorizedUser?: AuthorizedUser
    withBtn?: boolean
    className?: string
}> = ({ authorizedUser, withBtn, className }) => {
    return <div className={`${className || ''} flex flex-col items-center gap-[12px] lg:gap-10 mt-10 max-w-[600px]`}>
        <p className="text-[16px] lg:text-24  text-center text-shadow">
            {localize('sub_outdated_title')}
        </p>
        {
            withBtn
                ? authorizedUser && authorizedUser.authorized
                    ? <SubButton />
                    : <AuthButton />
                : <></>
        }
    </div>
}

export const HeroTemplateBlock: React.FC<{
    className?: string
    child?: any
}> = ({ child, className }) => {
    return (
        <div className="lg:block flex 2xl:w-full">
            <div className={`w-full bg-dark shadow-dark-l p-[50px] ${className ?? ''}`}>
                {child}
            </div>
        </div>
    );
};
